<template>
  <div
    :class="$style.border"
    :style="styles"
  >
    <span :class="$style.badge">
      <slot />
    </span>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseBadge',
  props: {
    color: {
      type: String,
      default: undefined
    }
  },
  computed: {
    styles() {
      return {
        backgroundColor: this.color
      };
    }
  }
});
</script>

<style module>
/* Разделено на 2 дива ибо при разных экранах и разных увеличениях шрифт мог быть то выше то ниже центра блока */
.border {
  display: inline-flex;
  border-radius: 4px;
  padding: 0 8px;
}

.badge {
  color: #101828;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  &:first-letter {
    text-transform: uppercase;
  }
}
</style>

<i18n lang="json">{}</i18n>
